import { render, staticRenderFns } from "./TableComponent.vue?vue&type=template&id=8b114b70&scoped=true"
import script from "./TableComponent.vue?vue&type=script&lang=ts"
export * from "./TableComponent.vue?vue&type=script&lang=ts"
import style0 from "./TableComponent.vue?vue&type=style&index=0&id=8b114b70&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b114b70",
  null
  
)

export default component.exports